<template>
  <td>
    <div v-if="showNullHtml" v-html="nullHtml"></div>
    <div v-else>
      <div v-if="url === null">
        {{ source.name }}
        <span v-if="asaModeator" class="badge badge-info">A</span>
      </div>
      <a v-else-if="noRouter" :href="url">
        {{ source.name }}
        <span v-if="asaModeator" class="badge badge-info">A</span>
      </a>
      <router-link v-else :to="url">
        {{ source.name }}
        <span v-if="asaModeator" class="badge badge-info">A</span>
      </router-link>
    </div>
  </td>
</template>

<script lang="babel">
import { defaultNullHtml } from "@/js/defaultNullHtml";

export default {
    props: ['model', 'content'],
    computed: {
      source () {
        if (this.content !== ''){
          return this.content;
        }
        return this.model;
      },
      showNullHtml() {
        return !this.source;
      },
      nullHtml() {
        return defaultNullHtml();
      },
      noRouter() {
        return !this.$route;
      },
      asaModeator() {
        return this.source.roles.some(el => el.name === "moderator") && this.model.asa_only;
      },
      url() {
        if (this.source.roles.some(el => el.name === "moderator" || el.name === "agency_leader")) {
          return `/moderator/detail/${this.source.id}`;
        } else {
          return null;
        }
      },
    }
};
</script>
